<div>
    <span class="text-danger h3">Error!</span>
  </div><br />
  <div>
    <span>Internal Error Accured .</span><br /><br />
    <span>please contact to site administrator.</span>
  </div>
  